/**
 * Token exchange endpoint path
 */
export const TOKEN_EXCHANGE_PATH = 'token-exchanges/lumapps-beekeeper';
